import * as React from "react";
import {
  IconBuildingHospital,
  IconCamera,
  IconDashboard,
  IconDatabase,
  IconFileAi,
  IconFileDescription,
  IconFileWord,
  IconHelp,
  IconReport,
  IconSearch,
  IconSettings,
  IconUsers,
} from "@tabler/icons-react";

import { NavMain } from "@/components/nav-main";
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
// import logo from "@/assets/logo.svg";
import { routes } from "@/app/routes";

const data = {
  user: {
    name: "shadcn",
    email: "m@example.com",
    avatar: "/avatars/shadcn.jpg",
  },
  navMain: [
    {
      title: "Dni",
      url: routes.days.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.days.path,
    },
    {
      title: "Sale",
      url: routes.rooms.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.rooms.path,
    },
    {
      title: "Sesje",
      url: routes.sessions.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.sessions.path,
    },
    {
      title: "Wykłady",
      url: routes.lectures.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.lectures.path,
    },
    {
      title: "Wystawcy",
      url: routes.companies.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.companies.path,
    },
    {
      title: "Wejściówki (PWZ/Legitymacja)",
      url: routes.participantPasses.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.participantPasses.path,
    },
    {
      title: "Uczestnicy",
      url: routes.participants.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.participants.path,
    },
    {
      title: "Personel",
      url: routes.attendants.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.attendants.path,
    },
    {
      title: "Konkursy",
      url: routes.contests.path,
      icon: IconDashboard,
      isActive: (path: string) => path === routes.contests.path,
    },
  ],
  navClouds: [
    {
      title: "Capture",
      icon: IconCamera,
      isActive: true,
      url: "#",
      items: [
        {
          title: "Active Proposals",
          url: "#",
        },
        {
          title: "Archived",
          url: "#",
        },
      ],
    },
    {
      title: "Proposal",
      icon: IconFileDescription,
      url: "#",
      items: [
        {
          title: "Active Proposals",
          url: "#",
        },
        {
          title: "Archived",
          url: "#",
        },
      ],
    },
    {
      title: "Prompts",
      icon: IconFileAi,
      url: "#",
      items: [
        {
          title: "Active Proposals",
          url: "#",
        },
        {
          title: "Archived",
          url: "#",
        },
      ],
    },
  ],
  navSecondary: [
    {
      title: "Settings",
      url: "#",
      icon: IconSettings,
    },
    {
      title: "Get Help",
      url: "#",
      icon: IconHelp,
    },
    {
      title: "Search",
      url: "#",
      icon: IconSearch,
    },
  ],
  documents: [
    {
      name: "Data Library",
      url: "#",
      icon: IconDatabase,
    },
    {
      name: "Reports",
      url: "#",
      icon: IconReport,
    },
    {
      name: "Word Assistant",
      url: "#",
      icon: IconFileWord,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="#" className="flex justify-center">
                {/*<img src={logo} className="logo react" alt="React logo" />*/}
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        {/*<NavDocuments items={data.documents} />*/}
        {/*<NavSecondary items={data.navSecondary} className="mt-auto" />*/}
      </SidebarContent>
      {/*<SidebarFooter>*/}
      {/*  <NavUser user={data.user} />*/}
      {/*</SidebarFooter>*/}
    </Sidebar>
  );
}
